import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

/**
 * 筛选出面包屑导航的路由
 * 筛选出最后一个路由的整个树形结构
 * 自定义查找字段, 根据最后一级某个字段查找完整树(整个父类)
 * @param val 要查找对比的值
 * @param data 要查找的数据
 * @param fKey 要查找对比的字段
 * @returns {*[]}
 */
const recursiveTreeByLastLevel = (val, data, fKey = 'value') => {
  let rData = []
  for (let i = 0, len = data.length; i < len; i++) {
    rData.push(data[i])
    if (data[i].children && data[i].children.length > 0) {
      rData = rData.concat(recursiveTreeByLastLevel(val, data[i].children, fKey))
      if (rData.some(item => item[fKey] === val)) return rData
    }
    if (data[i][fKey] === val) return rData
    rData = []
  }
  return rData
}
const whiteList = ['/login'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      const booAddRoutes = store.state.permission.booAddRoutes
      if (booAddRoutes) {
        next()
      } else {
        try {
          // get user info
          await store.dispatch('user/getInfo')
          const infoData = await store.dispatch('permission/getRouterForToken')
          const accessRoutes = await store.dispatch('permission/generateRoutes', infoData)
          await store.commit('permission/SET_BOO_ADD_ROUTES', true)
          router.addRoutes(accessRoutes.concat({ path: '*', redirect: '/404', hidden: true }))
          next({ ...to, replace: false })
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          next(`/login`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login`)
      NProgress.done()
    }
  }
})

// 因keep-alive无法对超过二级的页面保存状态,
// 参见BUG：https://github.com/PanJiaChen/vue-element-admin/issues/406
// 二三级菜单不能缓存本质是ParentView route-view没有找到导致不能被keep-live缓存,所以我们可以在全局路由守卫中直接找到ParentView路由并删除
// 解决方案：https://juejin.cn/post/7029571500550127624
// 另一种解决方案：https://juejin.cn/post/7129805992510324772
router.beforeResolve((to, from, next) => {
  if (to.matched && to.matched.length > 2) {
    to.matched.forEach((item, index) => {
      if (item.components.default && item.components.default.name === 'ParentView') {
        to.matched.splice(index, 1)
      }
    })
  }
  next()
})

router.afterEach((to) => {
  const routerList = recursiveTreeByLastLevel(to.name, store.state.permission.routes, 'name')
  store.commit('permission/SET_BREADCRUMB_LIST', routerList)
  // finish progress bar
  NProgress.done()
})
